module.exports = __webpack_public_path__ + "assets/icons-misc-misc-arrowbackward-24-px.40d2dca3.svg";